import {
  BlogPost,
  BlogCategory,
  BlogSearchParams,
  BlogPostListResponse,
} from "@/types/blog";
import { axiosWithoutToken } from "@/utils/axios";

class BlogServiceClass {
  /**
   * Fetch blog posts with pagination and filtering
   */
  GetBlogPosts(params?: BlogSearchParams) {
    return axiosWithoutToken.get<BlogPostListResponse>("/blog/posts", {
      params,
    });
  }

  /**
   * Fetch a single blog post by slug
   */
  GetBlogPostBySlug(slug: string) {
    return axiosWithoutToken.get<BlogPost>(`/blog/posts/${slug}`);
  }

  /**
   * Fetch a single blog post by ID
   */
  GetBlogPostById(id: string) {
    return axiosWithoutToken.get<BlogPost>(`/blog/posts/id/${id}`);
  }

  /**
   * Fetch all blog categories
   */
  GetBlogCategories() {
    return axiosWithoutToken.get<BlogCategory[]>("/blog/categories");
  }

  /**
   * Fetch posts by category slug
   */
  GetBlogPostsByCategory(
    categorySlug: string,
    params?: Omit<BlogSearchParams, "category">,
  ) {
    return axiosWithoutToken.get<BlogPostListResponse>(
      `/blog/categories/${categorySlug}/posts`,
      {
        params,
      },
    );
  }

  /**
   * Search blog posts
   */
  SearchBlogPosts(query: string, params?: Omit<BlogSearchParams, "query">) {
    return axiosWithoutToken.get<BlogPostListResponse>("/blog/posts/search", {
      params: {
        query,
        ...params,
      },
    });
  }

  /**
   * Fetch related blog posts
   */
  GetRelatedPosts(postId: string, limit: number = 3) {
    return axiosWithoutToken.get<BlogPost[]>(`/blog/posts/${postId}/related`, {
      params: { limit },
    });
  }

  /**
   * Increment post view count
   */
  IncrementPostViews(postId: string) {
    return axiosWithoutToken.post(`/blog/posts/${postId}/views`);
  }

  /**
   * Fetch popular blog posts
   */
  GetPopularPosts(limit: number = 5) {
    return axiosWithoutToken.get<BlogPost[]>("/blog/posts/popular", {
      params: { limit },
    });
  }

  /**
   * Fetch recent blog posts
   */
  GetRecentPosts(limit: number = 5) {
    return axiosWithoutToken.get<BlogPost[]>("/blog/posts/recent", {
      params: { limit },
    });
  }
}

const BlogService = new BlogServiceClass();
export default BlogService;
